import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import _ from 'lodash';

const defaultColors = ['#6464f2', '#619576', '#bcac76', '#9a6ee2'];

function CartProgressBarsColorsEditor({
  name,
  value,
  onChange,
}: {
  name: string;
  value: object;
  onChange: Function;
}) {
  const handleChange = (key: string, inputValue: string) =>
    onChange(name, {
      ...value,
      [key]: inputValue,
    });

  const handleBarColorChange = (index: number, inputValue: string) => {
    const colors = _.get(value, 'barColors', defaultColors);
    colors[index] = inputValue;
    onChange(name, {
      ...value,
      barColors: colors,
    });
  };
  return (
    <Row>
      <Col xs={12}>Färger för minimum ordervärdesindikator</Col>
      <Col>
        <Label>
          Textfärg
          <input
            className="d-block"
            type="color"
            name="textColor"
            value={_.get(value, 'textColor')}
            onChange={e => handleChange(e.target.name, e.target.value)}
          />
        </Label>
      </Col>
      <Col>
        <Label>
          Överskriftsfärg
          <input
            className="d-block"
            type="color"
            name="headerColor"
            value={_.get(value, 'headerColor')}
            onChange={e => handleChange(e.target.name, e.target.value)}
          />
        </Label>
      </Col>
      <Col>
        <Label>
          Färg 1
          <input
            className="d-block"
            type="color"
            name="color1"
            value={_.get(value, 'barColors[0]', defaultColors[0])}
            onChange={e => handleBarColorChange(0, e.target.value)}
          />
        </Label>
      </Col>
      <Col>
        <Label>
          Färg 2
          <input
            className="d-block"
            type="color"
            name="color2"
            value={_.get(value, 'barColors[1]', defaultColors[1])}
            onChange={e => handleBarColorChange(1, e.target.value)}
          />
        </Label>
      </Col>
      <Col>
        <Label>
          Färg 3
          <input
            className="d-block"
            type="color"
            name="color3"
            value={_.get(value, 'barColors[2]', defaultColors[2])}
            onChange={e => handleBarColorChange(2, e.target.value)}
          />
        </Label>
      </Col>
      <Col>
        <Label>
          Färg 4
          <input
            className="d-block"
            type="color"
            name="color4"
            value={_.get(value, 'barColors[3]', defaultColors[3])}
            onChange={e => handleBarColorChange(3, e.target.value)}
          />
        </Label>
      </Col>
    </Row>
  );
}

export default CartProgressBarsColorsEditor;
